/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-06-16 19:17:20
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-06-18 10:20:41
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\SystemSettings\LabelManage\api\index.js
 */
import request from '@/utils/req.js';

//标签库  左侧列表查询
export function apiLabel_leftData(params) {
    return request.post("/admin/label-database/list", params)
}
//标签库  左侧列表查询
export function apiLabel_leftData_new(params) {
    return request.post("/admin/label-database/listParentDataBase", params)
}
//标签库  右侧列表查询
export function apiLabel_leftData_page(params) {
    return request.post("/admin/label-database/page", params)
}
//标签库  右侧列表查询
export function apiLabel_leftData_page_new(params) {
    return request.post("/admin/label-database/pageLabelDataBase", params)
}
//标签库  编辑，标签
export function apiLabel_Edit(params) {
    return request.put("/admin/label-database", params)
}
//标签库添加分类
export function apiLabel_Add(params) {
    return request.post("/admin/label-database", params)
}
//标签库 删除 标签
export function apiLabel_Delete(params) {
    return request.delete(`/admin/label-database/${params}`)
}
//标签库 添加标签
export function apiLabelDown_Add(params) {
    return request.post("/admin/label-database/insertLabel",params)
}
//标签启用停用
export function apiLabel_enable(params) {
    return request.put(`/admin/label-database/updateStatus/${params}`)
}
//编辑分类
export function apiClass_Edit(params) {
    return request.put("/admin/label-database/updateLabelType",params)
}
//删除分类
export function apiClass_Delete(params) {
    return request.delete(`/admin/label-database/deleteLabelType/${params}`)
}

//个案编辑患者标签
export function apiLabel_InsertPatientLabel(params) {
    return request.post("/admin/patient-label/insertPatientLabel",params)
}

//引用
export function quoteLabelData(databaseId) {
  return request.get(`/admin/label-database/quote/${databaseId}`)
}

// 新增医生自定义标签
export function insertReturnId(params) {
  return request.post(`/admin/label-database/insertReturnId`, params)
}

// 编辑医生自定义标签
export function updateDoctorLabel(params) {
  return request.put(`/admin/label-database/updateLabel`, params)
}

// 删除医生自定义标签
export function deleteLabelForIds(params) {
    return request.post(`admin/label-database/deleteLabelForIds`, params)
}

//获取标签规则明细信息
export function getRuleDetailByLabelId(params) {
    return request.get("/biz/label-rule/getRuleDetailByLabelId", params);
}

//获取规则分类
export function getLabelRuleCategoryList(params) {
    return request.get("/biz/label-rule/category/getListByName", params);
}

//获取分类下的属性
export function getLabelRuleMetadataList(params) {
    return request.get("/biz/label-rule/metadata/getListByCategoryId", params);
}

//获取属性所有值(S1类型)
export function getS1AllValue(params) {
    return request.post("/biz/label-rule/metadata/getAllValue", params);
}

//枚举值列表查询(S3类型)
export function getS3AllValue(params) {
    return request.post("/biz/enums/list", params);
}

//检查表达式
export function checkExpression(params) {
    return request.post("/biz/label-rule/checkExpression", params);
}

//新增标签规则
export function saveLabelRule(params) {
    return request.post("/biz/label-rule/saveLabelRule", params);
}

//编辑标签规则
export function putLabelRule(params) {
    return request.put("/biz/label-rule", params);
}
